import axios from 'axios';

axios.defaults.withCredentials = true;

const API_URL = process.env.REACT_APP_API_URL;

// Lấy đơn bảo dưỡng sửa chữa mới
const BaoduongSuachuaMoi = async () => {
    try {
        const username = localStorage.getItem("username");

        if (!username) {
            throw new Error("Không tìm thấy username. Vui lòng đăng nhập lại.");
        }

        const response = await axios.get(`${API_URL}/don_bd_sc_moi`, {
            params: { username } 
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching chuyen kinh doanh:", error);
        throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

// Báo giá đơn bảo dưỡng sửa chữa
const Bao_Gia = async ({ id, gia, phu_phi }) => {
    try {
        const username = localStorage.getItem("username");

        if (!username) {
            throw new Error("Không tìm thấy username. Vui lòng đăng nhập lại.");
        }

        const response = await axios.post(`${API_URL}/bao_gia_bdsc`, {
            id,
            gia,
            phu_phi,
            username,
        });

        return response.data;
    } catch (error) {
        console.error("Lỗi khi gửi báo giá:", error);
        throw new Error("Không thể gửi báo giá! Vui lòng thử lại.");
    }
};

// Lấy đơn bảo dưỡng sửa chữa đang làm
const BaoduongSuachua = async () => {
    try {
        const username = localStorage.getItem("username");

        if (!username) {
            throw new Error("Không tìm thấy username. Vui lòng đăng nhập lại.");
        }

        const response = await axios.get(`${API_URL}/don_bd_sc`, {
            params: { username } 
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching chuyen kinh doanh:", error);
        throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

// Lấy lịch sử đơn bảo dưỡng sửa chữa
const LsBaoduongSuachua = async () => {
    try {
        const username = localStorage.getItem("username");

        if (!username) {
            throw new Error("Không tìm thấy username. Vui lòng đăng nhập lại.");
        }

        const response = await axios.get(`${API_URL}/ls_don_bd_sc`, {
            params: { username } 
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching chuyen kinh doanh:", error);
        throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

// Lấy thông tin chi phí phụ của đơn bảo dưỡng - sửa chữa nếu có
const Lay_CP_Bd_Sc = async (id) => {
    try {
        // Gọi API để lấy dữ liệu chi phí phụ của đơn bảo dưỡng - sửa chữa
        const response = await axios.get(`${API_URL}/lay_cp_bd_sc`, {
            params: {
                id: id,
            },
        });

        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi chi phí phụ của đơn bảo dưỡng - sửa chữa.', error);
        throw new Error('Không thể tải chi phí phụ của đơn bảo dưỡng - sửa chữa.');
    }
}

// Cập nhật trạng thái đơn bảo dưỡng - sửa chữa
const Update_Bd_Sc = async (id, trang_thai) => {
    try {
        const response = await axios.post(`${API_URL}/update_tt_bd_sc`, {
            id: id, 
            trang_thai: trang_thai,
        });
        return response.data; // Trả về dữ liệu phản hồi từ server
    } catch (error) {
        console.error('Lỗi khi cập nhật sửa chữa và bảo dưỡng:', error.response || error);
        throw new Error('Không thể cập nhật sửa chữa và bảo dưỡng. ' + (error.response?.data?.message || error.message));
    }
}


// Đặt tên cho object trước khi export
const RepairService = {
    BaoduongSuachuaMoi,
    BaoduongSuachua,
    LsBaoduongSuachua,
    Bao_Gia,
    Lay_CP_Bd_Sc,
    Update_Bd_Sc,
    
};

export default RepairService;
